// extracted by mini-css-extract-plugin
export var textInput = "_ng-0";